module.exports = __webpack_public_path__ + "img/kazakhstan.6f675407.svg";